export default "__VITE_ASSET__DMrmocQU__"